import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
  Grid,
  Slider,
  Box,
  TextField,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  Checkbox,
  Button,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import { convertArrayToDictionary, getDefailtGpt5xVal, hasLowReasoningEffortFloor, normalizeReasoningEffort } from "../../../common/utils";
import { useDispatch, useSelector } from "react-redux";
import { companiesSelector } from "../../../store/slices/company";
import {
  fetchprompts,
  triggerUpdatePrompt,
} from "../../../store/slices/prompts";
import { locationsSelector } from "../../../store/slices/location";
import { gptUsageLimit, llmList } from "../common/constant";

const ValueLabelComponent = (props) => {
  const { children, value } = props;
  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value + "k"}>
      {children}
    </Tooltip>
  );
};



const EditPrompts = ({
  open = false,
  handleClose = null,
  selectedPrompt = {},
  companyId,
}) => {
  const dispatch = useDispatch();
  const { users } = useSelector(locationsSelector);

  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [llm, setLlm] = useState("gpt-4");
  const [reviewType, setReviewType] = useState("None");
  const [passReviews, setPassReviews] = useState(true);
  const [description, setDescription] = useState("");
  const [reasoning_effort, setReasoningEffort] = React.useState('medium');
  const [verbosity, setVerbosity] = React.useState('medium');
  const [temperature, setTemperature] = useState(0);
  const [topP, setTopP] = useState(1);
  const [inputFactor, setInputFactor] = useState(40);
  const [jsonResponse, setJsonResponse] = useState(false);
  const [presencePenalty, setPresencePenalty] = useState(0);
  const [maxLength, setMaxLength] = useState(500);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0);
  const [promptText, setPromptText] = useState("");
  const [systemPrompt, setSystemPrompt] = useState("");

  useEffect(() => {
    if (selectedPrompt) {
      setName(selectedPrompt.name || "");
      setType(selectedPrompt.type || "Sentiments");
      setLlm(selectedPrompt.llm || "gpt-4o");
      setReviewType(selectedPrompt.reviewSelectionType || "None");
      setPassReviews(selectedPrompt?.processSingleReview);
      setDescription(selectedPrompt.description || "");
      setPromptText(selectedPrompt.promptText || "");
      setSystemPrompt(selectedPrompt.systemPrompt || "");
      if (selectedPrompt.defaultParameters) {
        const defaultParams = JSON.parse(selectedPrompt.defaultParameters);

        if ("verbosity" in defaultParams) {
          setVerbosity(defaultParams.verbosity);
        } else {
          setVerbosity('medium');
        }
        if ("reasoning_effort" in defaultParams) {
          setReasoningEffort(normalizeReasoningEffort(selectedPrompt.llm, defaultParams.reasoning_effort));
        } else {
          setReasoningEffort(getDefailtGpt5xVal(selectedPrompt.llm, 'medium'));
        }
        if ("temperature" in defaultParams) {
          setTemperature(parseFloat(defaultParams.temperature));
        } else {
          setTemperature(0);
        }

        if ("presencePenalty" in defaultParams) {
          setPresencePenalty(parseFloat(defaultParams.presencePenalty));
        } else {
          setPresencePenalty(0);
        }

        if ("maxLength" in defaultParams) {
          setMaxLength(parseInt(defaultParams.maxLength));
        } else {
          setMaxLength(500);
        }

        if ("frequencyPenalty" in defaultParams) {
          setFrequencyPenalty(parseFloat(defaultParams.frequencyPenalty));
        } else {
          setFrequencyPenalty(0);
        }
        if ("inputFactor" in defaultParams) {
          setInputFactor(parseInt(defaultParams.inputFactor));
        } else {
          setInputFactor(40);
        }
        if ("jsonResponse" in defaultParams) {
          setJsonResponse(Boolean(defaultParams.jsonResponse));
        } else {
          setJsonResponse(false);
        }
        if ("topP" in defaultParams) {
          setTopP(Boolean(defaultParams.topP));
        } else {
          setTopP(1);
        }
      }
    }
  }, [selectedPrompt]);

  const userDic = React.useMemo(
    () =>
      convertArrayToDictionary(
        _.map(_.cloneDeep(users), (it) => {
          it.name = it.firstName + (it.lastName ? " " + it.lastName : "");
          return it;
        }),
        "userId"
      ),
    [users]
  );
  const handleSliderChange = (slider) => (event, newValue) => {
    switch (slider) {
      case "temperature":
        setTemperature(newValue);
        break;
      case "presencePenalty":
        setPresencePenalty(newValue);
        break;
      case "maxLength":
        setMaxLength(newValue);
        break;
      case "frequencyPenalty":
        setFrequencyPenalty(newValue);
        break;
      case "inputFactor":
        setInputFactor(newValue);
        break;
      case "topP":
        setTopP(newValue);
        break;
      default:
        break;
    }
  };

  const onClose = () => {
    if (handleClose) {
      handleClose();
    }
  };
  const handleSubmit = () => {
    let obj = {
      name: name,
      type: type,
      description: description,
      reviewSelectionType: reviewType,
      promptText: promptText,
      systemPrompt: systemPrompt,
      llm: llm,
      processSingleReview: passReviews,
      defaultParameters: JSON.stringify({
        verbosity: verbosity,
        reasoning_effort: normalizeReasoningEffort(llm, reasoning_effort),
        temperature: temperature,
        maxLength: maxLength,
        presencePenalty: presencePenalty,
        frequencyPenalty: frequencyPenalty,
        inputFactor: inputFactor,
        jsonResponse: jsonResponse,
        topP: topP
      }),
    };
    if (selectedPrompt?.promptId) {
      dispatch(triggerUpdatePrompt(selectedPrompt?.promptId, selectedPrompt?.companyId, obj));
      // setTimeout(() => {
      //   dispatch(fetchprompts(selectedPrompt?.companyId));
      // }, 1000);
    }
  };
  // useEffect(()=>{
  //   if(llm==='gpt-5.1'|| llm==='gpt-5.2' || llm==='gpt-5.4'){
  //     setReasoningEffort('none');
  //   }else if(llm==='gpt-5-nano'){
  //     setReasoningEffort('minimal');
  //   }else{
  //     setReasoningEffort('medium');
  //   }
  // },[llm])
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Stack
          direction={"row"}
          spaicng={2}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="h4">Edit Prompts</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              disabled
              label="Name"
              size="small"
              variant="outlined"
              fullWidth
              value={name}
              sx={{ mt: 2 }}
              onChange={(e) => setName(e.target.value)}
            />

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth disabled>
                  <InputLabel>Type</InputLabel>
                  <Select
                    size="small"
                    label="Type"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    <MenuItem value="Sentiments">Sentiments</MenuItem>
                    <MenuItem value="Topics">Topics</MenuItem>
                    <MenuItem value="Response">Response</MenuItem>
                    <MenuItem value="Business">
                      Business
                    </MenuItem>
                    <MenuItem value="Review Request Email">
                      Review Request Email
                    </MenuItem>
                    <MenuItem value="Review Request SMS">
                      Review Request SMS
                    </MenuItem>
                    <MenuItem value="Phrase Summary">
                      Phrase Summary
                    </MenuItem>
                    <MenuItem value="Custom">Custom</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth disabled>
                  <InputLabel>LLM</InputLabel>
                  <Select
                    label="LLM"
                    size="small"
                    value={llm}
                    onChange={(e) => setLlm(e.target.value)}
                  >
                     {_.map(llmList, llm => <MenuItem key={llm} value={llm}>{llm}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth disabled>
                  <InputLabel>Review Selection Type</InputLabel>
                  <Select
                    label="Review Selection Type"
                    size="small"
                    value={reviewType}
                    onChange={(e) => setReviewType(e.target.value)}
                  >
                    <MenuItem value="None">None</MenuItem>
                    <MenuItem value="Single">Single</MenuItem>
                    <MenuItem value="Multiple">Multiple</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth disabled>
                  <InputLabel>Pass reviews to AI</InputLabel>
                  <Select
                    label="Pass reviews to AI"
                    size="small"
                    value={reviewType != "Multiple" ? " " : passReviews}
                    disabled
                    onChange={(e) => setPassReviews(e.target.value)}
                  >
                    <MenuItem value={false}>In batches</MenuItem>
                    <MenuItem value={true}>One at a time</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <TextField
              label="Description"
              size="small"
              sx={{ mt: 2 }}
              placeholder="Description"
              multiline
              rows={4}
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            <Box
              border={1}
              borderColor="lightgray"
              borderRadius={'6px'}
              p={2}
              mt={3}
              position="relative"
            >
              <Typography
                variant="subtitle1"
                align="center"
                style={{
                  position: "absolute",
                  top: -16,
                  left: 14,
                  // transform:
                  //   window.screen.width >= 1920
                  //     ? "translateX(-227%)"
                  //     : "translateX(-135%)",
                  backgroundColor: "white",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  color: "gray",
                  fontSize: "14px",
                }}
              >
                Default Parameters
              </Typography>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  columnGap: "24px",
                  padding: "0px 8px",
                }}
              >
                 <FormControl size="small" fullWidth>
                  <InputLabel>Verbosity</InputLabel>
                  <Select value={verbosity} label='Verbosity' onChange={e => setVerbosity(e.target.value)}>
                    <MenuItem value='low'>Low</MenuItem>
                    <MenuItem value='medium'>Medium</MenuItem>
                    <MenuItem value='high'>High</MenuItem>
                  </Select>
                </FormControl>

                <FormControl size="small" fullWidth>
                  <InputLabel>Reasoning Effort</InputLabel>
                  <Select value={reasoning_effort} label='Reasoning Effort' onChange={e => setReasoningEffort(e.target.value)}>
                    {!hasLowReasoningEffortFloor(llm) && <MenuItem value={getDefailtGpt5xVal(llm)}>{getDefailtGpt5xVal(llm) === 'none' ? 'None' : 'Minimal'}</MenuItem>}
                    <MenuItem value='low'>Low</MenuItem>
                    <MenuItem value='medium'>Medium</MenuItem>
                    <MenuItem value='high'>High</MenuItem>
                  </Select>
                </FormControl>


                <div>
                  <Typography>Temperature ({temperature})</Typography>
                  <Slider
                    value={temperature}
                    size="small"
                    min={0}
                    max={1}
                    step={0.01}
                    onChange={handleSliderChange("temperature")}
                    valueLabelDisplay="auto"
                  />
                </div>
                <div>
                  <Typography>Presence Penalty ({presencePenalty})</Typography>
                  <Slider
                    value={presencePenalty}
                    size="small"
                    min={0}
                    max={2}
                    step={0.01}
                    onChange={handleSliderChange("presencePenalty")}
                    valueLabelDisplay="auto"
                  />
                </div>
                <div>
                  <Typography>Max Input Length ({maxLength / 1000 + "k"})</Typography>
                  <Slider
                    value={maxLength / 1000}
                    // getAriaValueText={valuetext}
                    size="small"
                    min={0.5}
                    slots={{
                      valueLabel: ValueLabelComponent,
                    }}
                    max={gptUsageLimit[llm]}
                    step={0.5}
                    onChange={handleSliderChange("maxLength")}
                    valueLabelDisplay="auto"
                  />
                </div>
                <div>
                  <Typography>
                    Frequency Penalty ({frequencyPenalty})
                  </Typography>
                  <Slider
                    value={frequencyPenalty}
                    size="small"
                    min={0}
                    max={2}
                    step={0.01}
                    onChange={handleSliderChange("frequencyPenalty")}
                    valueLabelDisplay="auto"
                  />
                </div>
                {/* <div>
                  <Typography>Input Factor ({inputFactor + "%"})</Typography>
                  <Slider
                    value={inputFactor}
                    size="small"
                    min={10}
                    max={100}
                    step={5}
                    onChange={handleSliderChange("inputFactor")}
                    valueLabelDisplay="auto"
                  />
                </div> */}
                <div>
                  {/* <Typography>Input Factor ({inputFactor + '%'})</Typography> */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={jsonResponse}
                        onChange={(e) => setJsonResponse(e.target.checked)}
                      />
                    }
                    // labelPlacement="top"
                    label="Json Response"
                  />
                </div>
              </div>
            </Box>
            <Stack
              spacing={2}
              direction={'row'}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={name?.trim() === ""}

                >
                  {"Save"}
                </Button>
              </span>
              <Box sx={{ fontSize: "small" }} className="text-muted">
                <Stack>Prompt Id: {selectedPrompt?.promptId}</Stack>
                <Stack direction={"row"} sx={{ alignContent: "end" }}>
                  <Stack>
                    {" "}
                    Created by {userDic[selectedPrompt?.createdBy]?.name}
                  </Stack>
                  <Stack sx={{ pl: 0.5 }}>
                    on{" "}
                    {selectedPrompt?.createdOn
                      ? moment(selectedPrompt?.createdOn).format(
                        "MM/DD/YYYY hh:mm A"
                      )
                      : ""}{" "}
                  </Stack>
                </Stack>
                <Stack direction={"row"} sx={{ alignContent: "end" }}>
                  <Stack>
                    Last Modified{" "}
                    {typeof userDic[selectedPrompt?.modifiedBy]?.name !==
                      "undefined"
                      ? "by"
                      : ""}{" "}
                    {userDic[selectedPrompt?.modifiedBy]?.name}
                  </Stack>
                  <Stack sx={{ pl: 0.5 }}>
                    on{" "}
                    {selectedPrompt?.modifiedOn
                      ? moment(selectedPrompt?.modifiedOn).format(
                        "MM/DD/YYYY hh:mm A"
                      )
                      : ""}{" "}
                  </Stack>
                </Stack>
              </Box>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Prompt Text"
              sx={{ mt: 2 }}
              placeholder="Prompt Text"
              multiline
              rows={window.screen.height >= 1080 ? 22.5 : 12}
              fullWidth
              value={promptText}
              onChange={(e) => setPromptText(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default EditPrompts;
